module.exports = __webpack_public_path__ + "img/Chengg.1b06e3a3.svg";